import { Empty } from "antd";
import TranscriptStreamer from "./TranscriptStreamer";

const TranscriptView = ({ transcript,transcriptReceived }) => {
  if (transcript.length === 0) return <Empty description="No transcript available" />;

  
  
  if(!transcriptReceived) return

  return (
    <div style={{height:"100%"}} className="grid grid-cols-1 gap-4 text-lightText font-medium">
    <TranscriptStreamer transcript={transcript} />
      {/* {transcript.map((item, index) => (
        <div key={index} className="flex flex-col space-y-1">
          <div className="">
            {item.speaker} <span>[{item.timestamp}]</span>
          </div>
          <div>{item.text}</div>
        </div>
      ))} */}
    </div>
  );
};

export default TranscriptView;
